import { logger } from '@zep/core-logger';
import { useIsomorphicViewportDevice } from '@zep/react';
import { cn } from '@zep/utils';
import { CMS_CDN } from '../../../consts/env';
import S from './LandingApps.module.scss';
export const LandingApps = (props: LandingAppsProps) => {
  const {
    title,
    description,
    appLink
  } = props;
  const {
    isTablet,
    isMobile,
    isPortableDevice
  } = useIsomorphicViewportDevice();
  return <section className={S.apps} data-sentry-component="LandingApps" data-sentry-source-file="LandingApps.tsx">
      <div className={S.apps_info}>
        <div className={S.app_contents}>
          <div data-motion="scale-in" className={S.wrapper}>
            {}
            <img className={cn({
            'self-start': !isPortableDevice
          })} src="/images/light/landing/zep_app_square.png" width="60" height="60" alt="cheeck circle" />
            <h2 className={S.title}>{title}</h2>
            <p className={S.sub_descriptionription}>{description}</p>
          </div>
          {appLink && <div className={S.app_store} data-motion="scale-in">
              <a href={appLink.ios ?? 'itms-apps://apps.apple.com/app/zep/id1612428484'} target="_blank" onClick={() => logger.track('landing_ios_download')} rel="noreferrer">
                {}
                <img src={`${CMS_CDN}/medias/9z7bCJzn/nxF/pCbji3wK8aItvfpDUTg2nxF/en-US/1/apple.png`} width="130" height="38" alt="media" loading="lazy" />
              </a>
              <a href={appLink.android ?? 'https://play.google.com/store/apps/details?id=us.zep.mobile&hl=en&gl=US'} target="_blank" onClick={() => logger.track('landing_android_download')} rel="noreferrer">
                {}
                <img src={`${CMS_CDN}/medias/9z7bCJzn/8HT/f99DM3wK87XtvfpDUT6h8HT/en-US/1/goole.png`} width="130" height="38" alt="media" loading="lazy" />
              </a>
            </div>}
        </div>
        <div className={S.app_images} data-motion="scale-in">
          {isTablet || isMobile ? <img src={`${CMS_CDN}/medias/9z7bCJzn/HxK/uhVQD3wK890tvffZfWseHxK/en-US/1/Downloads_Tablet%2CMobile.png`} width="522" height="351" alt="media" loading="lazy" /> : <img src={`${CMS_CDN}/medias/9z7bCJzn/ODJ/r7MUE3wK8aGtvffZfV4IODJ/en-US/1/Downloads_Desktop.png`} width="689" height="400" alt="media" loading="lazy" />}
        </div>
      </div>
    </section>;
};
type LandingAppsProps = {
  title: string;
  description: string;
  appLink: {
    ios: string;
    android: string;
  };
  desktopImageSrc: string;
  mobileImageSrc: string;
};